module.exports = __webpack_public_path__ + "img/female.d85b8f36.svg";